module.exports = __webpack_public_path__ + "img/copy.c9354b4b.svg";